import loadable from '@loadable/component'

 const ComponentLoader = (type) => {    
     return loadable(() => import('../components/' + type))
 }

export default ComponentLoader;